import { Component } from '@angular/core';
import { UserService } from '../../../shared/services/user.service';
import { AdminLayout } from './admin-layout/admin-layout';
import { ClientLayout } from './client-layout/client-layout';

@Component({
  standalone: true,
  selector: 'app-app-layout',
  imports: [AdminLayout, ClientLayout],
  templateUrl: './app-layout.html',
  styleUrl: './app-layout.scss',
})
export class AppLayout {
  constructor(
    public userService: UserService,
  ) {}
}
